export const MAX_LOADS_FOR_ORDER = 20

/**
 * Terms a password must not contain. Matched case-insensitively as substrings,
 * so the casing here is only for readability.
 */
export const RESERVED_PASSWORD_TERMS = ['ROUTEMANAGER', 'WORKWAVE']
